import { MultiLangString } from './MultiLangString';

export enum SurveyStepType {
  /// A single choice question where only one option can be selected.
  multipleChoiceSingleSelect = 'multipleChoiceSingleSelect',

  /// A single choice question where only one option can be selected and the user can enter a text response. Used for Yes/No/Other type questions.
  multipleChoiceSingleSelectWithText = 'multipleChoiceSingleSelectWithText',

  /// A multiple choice question where multiple options can be selected.
  multipleChoiceMultiSelect = 'multipleChoiceMultiSelect',

  /// A multiple choice question where multiple options can be selected and one option allows text input (e.g., 'Other: [text]').
  multipleChoiceMultiSelectWithText = 'multipleChoiceMultiSelectWithText',

  /// Text input question.
  textInput = 'textInput',

  /// A simple yes/no question.
  yesNo = 'yesNo',

  /// A slider input question that allows the user to select a value within a range.
  slider = 'slider',

  /// A toggle switch question for enabling/disabling an option.
  toggleSwitch = 'toggleSwitch',

  /// A rating question (e.g., star rating or numeric rating).
  rating = 'rating',

  /// An information step to inform the user of important details or instructions.
  information = 'information',

  /// An introduction step to inform the user about the upcoming questions.
  introduction = 'introduction',

  /// A screen to display when the survey or questionnaire is successfully completed.
  successScreen = 'successScreen',

  /// collect an address
  address = 'address',

}

export enum SurveyOptionAction {
  next = 'next',
  previous = 'previous',
  submit = 'submit',
  skip = 'skip',
  goto = 'goto',
  none = 'none',
}

export type SurveyInputType = 'text' | 'number' | 'email' | 'phone' | 'multiline' | 'year';

export interface SurveyOption {
  _id: string;
  text: MultiLangString;
  description: MultiLangString;
  reportText: MultiLangString;
  reportDescription: MultiLangString;
  value: string;
  action: SurveyOptionAction;
  inputType?: SurveyInputType; // Only present if this option requires input
  actionPayload?: string; // Id of the question to navigate to for goto action
}

export interface SurveyStep {
  _id: string;
  stepType: SurveyStepType;
  title: MultiLangString;
  description: MultiLangString;
  reportTitle: MultiLangString;
  reportDescription: MultiLangString;
  options: SurveyOption[];
  notes?: string[]; // Optional notes to display after options
}

export interface SurveyModel {
  _id: string;
  steps: SurveyStep[];
}

export interface SurveyResponse {
  stepId: string;
  showValueInReport: boolean;

  response: {
    _id: string; // The _id of the SurveyOption
    values: string[]; // The values for this option (could be the option value, or user input for text/multiline)
  }[];
}

export interface SurveyReportModel {
  stepId: string;
  stepType: SurveyStepType;
  reportTitle: MultiLangString;
  reportDescription: MultiLangString;
  responses: SurveyReportResponseModel[];
}

export interface SurveyReportResponseModel {
  _id: string;
  reportText: MultiLangString;
  reportDescription: MultiLangString;
  showValueInReport?: boolean;
  values: string[];
}
